'use client'
import { useState } from 'react'
import Image from 'next/image'
import type { ImageFragment, ProductFragment } from '@/lib/types/datocms/graphql/generated'
import Modal from '@/components/Modal'
import Icon from '@/components/svg/icon'
import CarouselInModal from '@/components/CarouselInModal'
import clsx from 'clsx'

type Props = {
	gallery: ProductFragment['gallery']
	inMegaMenu?: boolean
}

export function Gallery({ gallery, inMegaMenu }: Props) {
	const [isImageModalOpen, setIsImageModalOpen] = useState(false)
	const [activeImageIndex, setActiveImageIndex] = useState(0)

	return (
		<div
			className={clsx(
				'gallery grid grid-cols-3 gap-2 max-w-screen-2xl mx-auto pb-4',
				!inMegaMenu && 'common-x-padding py-10'
			)}
		>
			{gallery.map((image: ImageFragment, index: number) => (
				<button
					className="group relative rounded-md overflow-hidden"
					key={image.id as string}
					onClick={() => {
						setActiveImageIndex(index)
						setIsImageModalOpen(true)
					}}
				>
					<Image
						key={image.id as string}
						src={image.url}
						width={100}
						height={100}
						alt={image.alt ?? 'Gallery image'}
						className="h-full w-full object-cover bg-white-frosted"
						sizes="33%"
					/>
					<div
						className={clsx(
							'absolute top-2 right-2 bg-white/70 rounded-md p-1 group-hover:bg-white group-hover:text-blue transition-colors duration-300',
							inMegaMenu && 'hidden'
						)}
					>
						<Icon icon="Enlarge" />
					</div>
				</button>
			))}

			<Modal isOpen={isImageModalOpen} onClose={() => setIsImageModalOpen(false)}>
				<CarouselInModal
					gallery={gallery as { url: string; alt: string }[]}
					activeImageIndex={activeImageIndex}
					setActiveImageIndex={setActiveImageIndex}
				/>
			</Modal>
		</div>
	)
}
